/* eslint-disable @typescript-eslint/no-explicit-any */
export const useConditionalPageContextSERP = (): {
  pageState: any;
  isAuthorMode: boolean;
  currentLocale?: string;
  featureFlagLogo?: Record<string, any>;
  sessionData?: any;
} => {
  return {
    pageState: null,
    isAuthorMode: false,
    currentLocale: 'en-US',
    featureFlagLogo: undefined,
    sessionData: undefined,
  };
};
